import type { ReactNode } from 'react'
import { CompanyRequiredRoute } from './CompanyRequiredRoute'

export interface ProtectedPageProps {
  children: ReactNode
  requireCompany?: boolean
}

export function ProtectedPage({ children, requireCompany = true }: ProtectedPageProps) {
  if (!requireCompany) {
    return children
  }

  return <CompanyRequiredRoute>{children}</CompanyRequiredRoute>
}
